import { connect } from 'react-redux';

import { changePage } from '../../redux/app';
import { fundColumns } from '../../service/tickercolumns';
import {
    updateFund,
    newFunds,
    fetchFunds,
    changeFundsFilters,
    loadingFunds,
} from '../../actions/funds';

import withPageTitle from '../../hoc/withPageTitle';
import withTableSubscription from '../../hoc/withTableSubscription';
import FundsPage from '../../components/pages/FundsPage';

const sources = 'feed.omff.FUNDS';

function mapStateToProps({ funds }) {
    return {
        title: 'Fond',
        ...funds,
        sources,
        columns: fundColumns,
    };
}

const mapDispatchToProps = {
    changePage,
    update: updateFund,
    create: newFunds,
    fetch: fetchFunds,
    changeFilters: changeFundsFilters,
    loadingFunds,
};

export default connect(mapStateToProps, mapDispatchToProps)(
    withTableSubscription(withPageTitle(FundsPage))
);



/** WEBPACK FOOTER **
 ** /src/shared/containers/pages/FundsPage.js
 **/